import React, { Component } from 'react';

import './index.css'
import { BsyUtils } from '../../utils/Utils';
import { BsyWidget } from '../BsyWidget';
import BsyTextEditor from '../BsyTextEditor';
import { BsyConfig } from '../../global/BsyConfig';

export default class BsySelectListCheckBox extends BsyWidget {

    constructor(props) {
        super({
            baseCls: "fui_checklist",
            hasSelectAll: !0,
            hasSelectEmpty: !0,
            emptySelectText: React.language("unfilled"),
            textField: "text",
            valueField: "value",
            async: null,
            asyncResultKey: props.asyncResultKey ? props.asyncResultKey : "items",
            value: [],
            customItem: null,
            items: [{
                value: React.language("field.options", { num: 1 }),
                text: React.language("field.options", { num: 1 })
            }, {
                value: React.language("field.options", { num: 2 }),
                text: React.language("field.options", { num: 2 })
            }, {
                value: React.language("field.options", { num: 3 }),
                text: React.language("field.options", { num: 3 })
            }],
            allowEmptyTextField: !1,
            searchable: !0,
            onStopEdit: null,
            height: 30,
            width: 240,
            limit: 100,
            hasLimit: !1,
            onAfterItemSelect: null,
            onAfterSelectAll: null,
            searchKey: "keyword",
            ...props
        });
        this.state = {
            css: {},
            seaching: false,
            value: this.options.value,
            items: this.options.items
        }
        this.page = 0;
        this.isAllSelect = false;
        this.listRef = React.createRef();
    }

    onMoreData = (cb) => {
        this.page++;
        const { async, limit } = this.options;
        this.loadData(this.page * limit, () => {
            cb && cb(this.state.items, this.isMore);
        });
    };

    loadData = (skip, cb) => {

        const { async, hasLimit, limit, authGroupId, popupFormPath, asyncResultKey, textField, valueField, hasSelectEmpty, emptySelectText } = this.options;
        if (BsyUtils.isObjectEmpty(async)) {
            let dd = [];
            if (hasSelectEmpty) {
                if (BsyUtils.isObjectEmpty(this.searchValue)) {
                    dd.push({
                        [textField]: emptySelectText,
                        [valueField]: BsyConfig().CONST.PARAMETER.EMPTY,
                    })
                }
            }

            this.setState({
                items: dd,
                seaching: !1,
            }, () => {
                cb && cb()
            })
            return;
        }
        let n = {
            hasLimit: hasLimit,
            skip: skip,
            limit: limit,
            authGroupId: authGroupId,
            popupFormPath: popupFormPath ? [...popupFormPath] : undefined,
            ...async.data
        };
        if (['combo', 'combocheck'].indexOf(this.options.type) > -1) {
            n.popupFormPath = undefined;
        }
        if (n.hasOwnProperty("hasCurrentUser")) {
            if (BsyUtils.isObjectEmpty(n.filter) || BsyUtils.isObjectEmpty(n.filter.cond))
                n.hasCurrentUser = true;
            else {
                n.hasCurrentUser = false;
            }
        }
        if (!BsyUtils.isObjectEmpty(this.searchValue)) {
            n.keyword = this.searchValue + "";
            if (n.hasOwnProperty("hasCurrentUser")) {
                n.hasCurrentUser = false;
            }
        }
        if (this.options.designAppId) {
            n.designAppId = this.options.designAppId;
            n.designEntryId = this.options.designEntryId;
            n.widgetName = this.options.orgWidgetName || this.options.widgetName;
            n.subformName = this.options.subformName || this.options.subform;
        }

        React.axios(async.url, {
            ...n,
        }).then(res => {
            BsyUtils.showAjaxTip(res.data, () => {
                let dd = [];
                if (hasSelectEmpty) {
                    if (BsyUtils.isObjectEmpty(this.searchValue)) {
                        dd.push({
                            [textField]: emptySelectText,
                            [valueField]: BsyConfig().CONST.PARAMETER.EMPTY,
                        })
                    }
                }
                if (res.data[asyncResultKey])
                    this.isMore = res.data[asyncResultKey].length === limit;

                BsyUtils.forEach(res.data[asyncResultKey], (a1, b1) => {
                    if (BsyUtils.isString(b1) || BsyUtils.isNumber(b1)) {
                        dd.push({
                            ...res.data[asyncResultKey][a1],
                            [textField]: b1 + '',
                            [valueField]: b1 + '',
                        })
                    } else {
                        dd.push({
                            ...res.data[asyncResultKey][a1],
                            [textField]: b1[textField],
                            [valueField]: b1[valueField],

                        })
                    }
                })

                let ddc = [];

                if (skip > 0) {
                    if (this.state.items) ddc = [...this.state.items];
                }
                ddc = ddc.concat(dd);

                this.setState({
                    items: ddc,
                    seaching: !1,
                    isMore: this.isMore,
                }, () => {
                    cb && cb()
                })


            })

        }).catch(res => {
            console.error(res);

        })

    }

    onScroll = (e) => {
        const { isMore } = this.state;

        if (isMore) {
            if (this.listRef && this.listRef.current) {
                if (
                    this.listRef.current.offsetHeight <=
                    e.target.scrollTop + e.target.offsetHeight + 10
                ) {
                    this.setState(
                        {
                            isMore: false,
                        },
                        () => {

                            this.onMoreData((items, isMore) => {
                                this.setState({
                                    items: [...items],
                                    isMore: isMore,
                                });
                            });

                            console.log("操作更多");
                        }
                    );
                }
            }
        }
    };

    componentDidMount() {
        super.componentDidMount();

        this.loadData(0);
    }


    selectItem = (val) => {

        return () => {
            const { items, value } = this.state
            const { textField, valueField } = this.options;
            let newValue = [];
            if (this.searchValue) {
                newValue = [...value] // 搜索的时候，是追加赋值
            }
            let isallSelect = true;
            const newitems = items.map((v) => {

                let selected = value.indexOf(v[valueField]) > -1;
                if (val === v[valueField]) {
                    selected = !selected;
                }

                if (selected) {
                    newValue.push(v[valueField])
                } else {
                    isallSelect = false;
                }
                return v
            })
            this.isAllSelect = isallSelect;
            this.setState({ value: newValue }, () => {
                if (this.props.onSelect) {
                    this.props.onSelect(this.state.value)
                } else {
                    if (this.props.onStopEdit) {
                        this.props.onStopEdit(this.state.value)
                    }
                }
            })
        }
    }

    getValue = () => {
        return this.state.value
    }


    seachItems = (val) => {
        let that = this;
        if (this.searchValue !== val) {
            this.searchinterval && clearTimeout(this.searchinterval)
            this.searchValue = val;
            this.setState({
                seaching: true
            })
            this.searchinterval = setTimeout(function () {
                that.seachCallBack();
            }, 500)
        }
    }

    seachCallBack = () => {
        const { items } = this.state
        const { textField } = this.options;
        if (!this.searchValue) {
            this.setState({
                items: this.bakAllitems,
                seaching: false,
            }, () => {
                this.bakAllitems = null;
            })
        } else {
            if (BsyUtils.isObjectEmpty(this.bakAllitems)) {
                this.bakAllitems = [...items]
            }
            this.loadData(0)

        }

    }

    onSelectAll = () => {
        const { isAllSelect } = this
        const { items, value } = this.state
        const { valueField } = this.options
        let tmpvalue = value ? [...value] : [];
        let isallSelect = !isAllSelect;
        // let values = [];
        const newitems = items.map((data, index) => {
            let d = tmpvalue.indexOf(data[valueField]);
            if (isallSelect) {
                if (d == -1) {
                    tmpvalue.push(data[valueField]);
                }
            } else {

                if (d > -1) {
                    tmpvalue.splice(d, 1);
                }
            }
            return data;
        })
        this.isAllSelect = isallSelect;
        if (!this.isAllSelect) {
            tmpvalue = [];
        }
        this.setState({
            items: [...newitems],
            value: tmpvalue,
        }, () => {
            if (this.props.onSelect) {
                this.props.onSelect(this.state.value)
            } else {
                if (this.props.onStopEdit) {
                    this.props.onStopEdit(this.state.value)
                }
            }
        })
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        if (!BsyUtils.compare(this.state.value, nextProps.value)) {
            this.setState({
                value: [...nextProps.value],
            }, () => {
                if (this.props.onStopEdit) {
                    this.props.onStopEdit(nextProps.value)
                }
            })
        }
    }

    renderSelectList = () => {
        const { searchable, hasSelectAll, textField, valueField } = this.options
        const { css, items, value, seaching, isMore } = this.state
        const { isAllSelect } = this;
        return <>
            {
                searchable ? <div className='bsy-combo-search' >

                    <BsyTextEditor
                        onAfterEdit={this.seachItems}
                        waterMark={React.language("search")}
                        width={"100%"}
                        value={this.searchValue}
                    ></BsyTextEditor>

                </div> : <></>
            }
            <div style={css} className="selectList"
                onScroll={this.onScroll}
            >

                <div style={{ overflow: "hidden" }} ref={this.listRef}>
                    {
                        seaching && <div className='loading-text'>
                            <span>{React.language('searching')}</span>
                        </div>
                    }
                    {
                        (!seaching && hasSelectAll) ? <div key={'all'}
                            onClick={this.onSelectAll}
                            className={"item bsy-x-check select-all field-meta " + (isAllSelect ? 'select' : '')}

                        >
                            <i className="icon-blank"></i>
                            <span style={{ color: '#0265ff' }}>
                                {
                                    BsyUtils.isObjectEmpty(this.searchValue) ? React.language('selectAll') : React.language('selectAllSearchResult')
                                }
                            </span>
                        </div> : <></>
                    }
                    {

                        !seaching && items && items.map((val) => {

                            if (value.indexOf(val[valueField]) > -1) {
                                val.selected = true;
                            } else {
                                val.selected = false;
                            }


                            if (this.props.onCustomItem) {
                                return <div key={val[valueField]} onClick={this.selectItem(val[valueField])} className={val.selected ? " item bsy-x-check select " : "item bsy-x-check "}>
                                    <i className="icon-blank"></i>
                                    {
                                        this.props.onCustomItem(val)
                                    }
                                </div>
                            }

                            return <div key={val[valueField]}
                                title={val[textField]}
                                onClick={this.selectItem(val[valueField])} className={val.selected ? " item bsy-x-check select " : "item bsy-x-check "}>
                                <i className="icon-blank"></i>
                                <span>
                                    {
                                        val[textField]
                                    }
                                </span>

                            </div>
                        })


                    }
                    {!seaching && isMore ? (
                        <div className="loading">{React.language("loading")}</div>
                    ) : (
                        ""
                    )}
                </div>
            </div>
        </>


    }

    render() {

        return (
            <div className={"BsySelectList "} ref={this.element} >
                {
                    this.renderSelectList()
                }
            </div>
        );
    }
}
